import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">Sobre Nosotros</h2>
        <p className="section-subtitle">Servicio profesional de gestión de citas de extranjería</p>
        
        <div className="about-content">
          <div className="about-main-content">
            <div className="about-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80" 
                alt="Oficina profesional en España" 
                className="about-image"
              />
              <div className="about-image-overlay"></div>
            </div>
            <div className="about-text-content">
              <p className="about-text">
                Somos un servicio profesional de gestión de citas de extranjería con más de 5 años de experiencia apoyando a particulares, agencias y despachos legales en toda España.
              </p>
              <p className="about-text">
                A lo largo de los años, hemos asistido exitosamente a más de 1000 clientes y colaborado con más de 30 despachos de abogados y gestorías, ayudándoles a gestionar citas de alta demanda de forma eficiente y confiable.
              </p>
            </div>
          </div>

          <div className="about-stats">
            <div className="stat-card">
              <div className="stat-icon">📅</div>
              <div className="stat-number">5+</div>
              <div className="stat-label">Años de Experiencia</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-number">1000+</div>
              <div className="stat-label">Clientes Atendidos</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⚖️</div>
              <div className="stat-number">30+</div>
              <div className="stat-label">Despachos Colaboradores</div>
            </div>
          </div>

          <div className="about-focus">
            <div className="about-focus-image">
              <img 
                src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80" 
                alt="Documentos y gestión profesional" 
                className="focus-image"
              />
            </div>
            <div className="about-focus-content">
              <h3 className="about-focus-title">Nuestro Trabajo</h3>
              <p className="about-text">
                Nuestro trabajo se centra en monitorear la disponibilidad, gestionar la logística de las citas y reducir los retrasos para procedimientos como Asilo, NIE, Huellas y renovaciones de Extranjería.
              </p>
              <p className="about-text">
                Priorizamos la transparencia, la privacidad de datos y la comunicación clara en cada paso del proceso.
              </p>
            </div>
          </div>

          <p className="about-text about-highlight">
            Operamos de forma independiente y ofrecemos servicios estructurados de gestión de citas diseñados para ahorrar tiempo y simplificar procesos complejos para nuestros clientes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
